import { render, staticRenderFns } from "./TimeInTemporaryStatus.vue?vue&type=template&id=8fd93a44&scoped=true&"
import script from "./TimeInTemporaryStatus.vue?vue&type=script&lang=js&"
export * from "./TimeInTemporaryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd93a44",
  null
  
)

export default component.exports